import FlagAR from '@/public/images/flags/flag-AR.svg';
import FlagBR from '@/public/images/flags/flag-BR.svg';
import FlagMX from '@/public/images/flags/flag-MX.svg';
import FlagUS from '@/public/images/flags/flag-US.svg';
import FlagUY from '@/public/images/flags/flag-UY.svg';
import FlagPE from '@/public/images/flags/flag-PE.svg';
import FlagEC from '@/public/images/flags/flag-EC.svg';
import FlagOther from '@/public/images/flags/flag-other.svg';

const CURRENCY_FLAGS = {
  ARS: FlagAR,
  USD: FlagUS,
  BRL: FlagBR,
  MXN: FlagMX,
  UYU: FlagUY,
  PEN: FlagPE,
  ECS: FlagEC,
  '000': FlagOther,

  // pendent flags
  PYG: FlagOther,
  CLP: FlagOther,
};

/**
 * Transforms an array of currency codes into objects with their assigned flag.
 *
 * @param {string[]} currencies - List of currency codes (e.g., ["ARS", "USD"]).
 * @returns {{ id: string, value: string, flag: string|null }[]}
 *   Array of objects with `id`, `value`, and `flag`.
 */
export default function mapCurrencyFlags(currencies) {
  return currencies.map((currency) => ({
    id: currency,
    value: currency,
    flag: CURRENCY_FLAGS[currency] ?? FlagOther,
  }));
}

/**
 * Returns the flag image for a single currency code.
 * Useful for rendering a flag directly without needing the full mapped array.
 *
 * @param {string} code - ISO 4217 currency code (e.g. "BRL").
 * @returns {string} Flag image module (falls back to flag-other).
 */
export function getFlagByCurrencyCode(code) {
  return CURRENCY_FLAGS[code] ?? FlagOther;
}
